<template>
  <Card>
    <AjaxForm route="admin/app/setLawModalHtml">
      <label>متن مودال :</label>
      <input type="hidden" name="content" v-model="content" hidden readonly >
      <editor v-model="content" api-key="f60dl4sz819mfm6cps7g9825ms3y9brgz2hlbiwc610e2mbd"
              :init="{
                     language: 'fa',
                     directionality : 'rtl',
                     menubar: false,
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor forecolor | \
                     alignright aligncenter alignleft alignjustify | \
                     bullist numlist outdent indent | removeformat'}"
      ></editor>
      <div class="row">
        <div class="col-12 col-sm-10 col-md-5 mx-auto my-3">
          <button class="btn btn-info btn-block" type="submit">ویرایش متن</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import Editor from '@tinymce/tinymce-vue'
import {AppApi} from "@/api/AppApi";
import AjaxForm from "@/components/forms/AjaxForm";
export default {
  name: "lawModal",
  components: {AjaxForm, Card,Editor},
  data()
  {
    return{
      content : '',
    }
  },
  mounted()
  {
    this.setPageTitle('متن مودال قوانین و مقررات');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      const result = await AppApi.getLawModalHtml();
      if (result.ok)
      {
        this.content = result.html;
      }
      else
        this.error = result.error;

      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>